import { render, staticRenderFns } from "./activitySuccessPage.vue?vue&type=template&id=0cc1a8d8&scoped=true"
import script from "./activitySuccessPage.vue?vue&type=script&lang=js"
export * from "./activitySuccessPage.vue?vue&type=script&lang=js"
import style0 from "./activitySuccessPage.vue?vue&type=style&index=0&id=0cc1a8d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1a8d8",
  null
  
)

export default component.exports